/* 组装并导出store */

import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import cart from './modules/cart'
import cartNew from './modules/cart-new'
import indexBanner from './modules/swiper_banner'
import Active from './modules/active'
Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    cart,cartNew,indexBanner,Active
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js